<template>
  <div class="hrproject-status" :class="getProjectStatusClass">
    {{ getProjectStatus }}
  </div>
</template>

<script>
import { PROJECT_STATUS_TITLES, PROJECT_STATUSES } from '@/common/constants/projectStatuses';

export default {
  name: 'ProjectIndicator',
  components: {
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  computed: {
    getProjectStatus() {
      const key = Object.keys(PROJECT_STATUSES).find(k => PROJECT_STATUSES[k] === this.project.status);
      return key ? PROJECT_STATUS_TITLES[key] : 'Не найдено';
    },
    getProjectStatusClass() {
      const key = Object.keys(PROJECT_STATUSES).find(k => PROJECT_STATUSES[k] === this.project.status);
      switch (key) {
        case 'COMPLETED': return 'hrproject-status-completed';
        case 'IN_PROGRESS': return 'hrproject-status-in-progress';
        default: return '';
      }
    },
  },
};
</script>

<style lang="scss">
.hrproject-status {
  border-radius: 2px;
  height: 27px ;
  width: 180px;
  padding: 2px 10px;
  text-align: center;
  background: #E4E4E4;
  border: 1px solid #818181;
  color: #818181;
  font-size: 0.875rem;
}

.hrproject-status-completed {
  background: #DCF1E4;
  border: 1px solid #42C32C;
  color: #42C32C;
}

.hrproject-status-in-progress {
  background: #E1F1FF;
  border: 1px solid #89AAFF;
  color: #89AAFF;
}

</style>
